// src/utils/request.js
import axios from "axios";
import qs from "qs";

const request = axios.create({
  baseURL: "/api",
});

// request.interceptors.request.use((config) => {
//   const token = localStorage.getItem("token");
//   if (token) {
//     config.headers.Authorization = `Bearer ${token}`;
//     config.headers["Content-Type"] = "application/json";
//   } else {
//     return <Navigate to="/login" replace />;
//   }
//   return config;
// });
// request.interceptors.response.use(
//   (res) => res,
//   (error) => {
//     if (error.response?.status === 401) {
//       // Token 过期或无效，重定向到登录页面
//       window.location.href = "/login";
//     }
//     return Promise.reject(error);
//   }
// );

request.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");

  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }

  if (config.method?.toLowerCase() === "get" && config.params) {
    // 过滤 + transform
    config.params = Object.fromEntries(
      Object.entries(config.params)
        .filter(
          ([_, v]) =>
            v !== null &&
            v !== undefined &&
            !(typeof v === "string" && !v.trim()) &&
            !(Array.isArray(v) && v.length === 0),
        )
        .map(([k, v]) => [
          k,

          // 字符串自动 trim
          typeof v === "string"
            ? v.trim()
            : // 如果数组里可能有字符串，也顺手 trim
              Array.isArray(v)
              ? v.map((item) => (typeof item === "string" ? item.trim() : item))
              : v,
        ]),
    );

    config.paramsSerializer = (params) =>
      qs.stringify(params, {
        arrayFormat: "repeat",
      });
  }

  return config;
});

request.interceptors.response.use(
  (res) => res,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem("token");
      window.location.href = "/login";
    }
    return Promise.reject(error);
  },
);
export default request;
